/* Szállítási határidő-kijelző (2026-08-18): variáns-váltás követése + cut-off utáni szöveg-váltás.
   Az adat a snippet inline JSON-jából jön; az elem AJAX-os újrarender után is feléled (observer). */
(function () {
  if (window.__wkSzallit) return;
  window.__wkSzallit = true;

  /* ===================== MUNKANAPTÁR (user-tények 2026-09-12) =====================
     - A raktár CSAK MUNKANAPON ad fel, a cut-off óráig leadott rendelést még aznap.
     - Péntek feladásnál a GLS Budapesten SZOMBATON kézbesít (csomagpontra és házhoz is), vidékre hétfőn.
     - Szombat, vasárnap és ünnepnap: nincs feladás → a csomag a következő munkanapon indul.
     A szünnapok a snippetből jönnek (data-szunnapok), mert a Liquid-oldal cache-elt: időfüggés csak itt lehet. */

  var PENTEK = 5;
  var NAP_MS = 86400000;

  /** A bolt időzónája szerinti mai nap (UTC-re horgonyozva, nap-aritmetikához) és az aktuális óra. */
  function maiNap(tz) {
    try {
      var reszek = new Intl.DateTimeFormat('en-CA', {
        timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23',
      }).formatToParts(new Date());
      var m = {};
      reszek.forEach(function (r) { m[r.type] = r.value; });
      return { nap: new Date(Date.UTC(Number(m.year), Number(m.month) - 1, Number(m.day))), ora: Number(m.hour) % 24 };
    } catch (e) {
      var d = new Date();
      return { nap: new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())), ora: d.getHours() };
    }
  }

  function isoNap(d) { return d.toISOString().slice(0, 10); }
  function plusz(d, n) { return new Date(d.getTime() + n * NAP_MS); }

  function munkanapE(d, szunnapok) {
    var n = d.getUTCDay();
    if (n === 0 || n === 6) return false;
    return szunnapok.indexOf(isoNap(d)) === -1;
  }

  function kovetkezoMunkanap(d, szunnapok) {
    var k = plusz(d, 1);
    for (var i = 0; i < 21 && !munkanapE(k, szunnapok); i++) k = plusz(k, 1);
    return k;
  }

  /** Feladás és érkezés napjai. bp = budapesti, videk = vidéki érkezés (péntek feladásnál térnek el). */
  function naptar(ma, ora, cutoff, szunnapok) {
    var aznapFelad = munkanapE(ma, szunnapok) && ora < cutoff;
    var felad = aznapFelad ? ma : kovetkezoMunkanap(ma, szunnapok);
    var videk = kovetkezoMunkanap(felad, szunnapok);
    var szombat = plusz(felad, 1);
    var szombatiKezbesites = felad.getUTCDay() === PENTEK && szunnapok.indexOf(isoNap(szombat)) === -1;
    return { aznapFelad: aznapFelad, felad: felad, bp: szombatiKezbesites ? szombat : videk, videk: videk };
  }

  /* ===================== NYELVI SZÓTÁR (2026-09-12, user: a határidő-sorok minden nyelven) =====================
     A napok kifejezései a téma nyelvi fájljából jönnek (locales/*.json → wk_szallitas), mert a nyelvtan nyelvenként más
     („hétfő reggelre" / „Montag früh" / „v pondělí ráno"). A beépített magyar csak tartalék, ha a szótár hiányos. */

  var MAGYAR_SZOTAR = {
    nap_reggel: ['vasárnap reggelre', 'hétfő reggelre', 'kedd reggelre', 'szerda reggelre',
      'csütörtök reggelre', 'péntek reggelre', 'szombat reggelre'],
    nap_on: ['vasárnap', 'hétfőn', 'kedden', 'szerdán', 'csütörtökön', 'pénteken', 'szombaton'],
    holnap_reggel: 'holnap reggelre',
    holnap_on: 'holnap',
    bp_videk: 'Budapesten {bp}, vidéken {videk}',
    utvonal: {},
  };
  var NAPOK_SZAMA = 7;

  /** A Shopify a hiányzó fordítás helyére „translation missing: …" szöveget ír — ezt hiányként kezeljük. */
  function ervenyes(s) {
    return typeof s === 'string' && s.length > 0 && !/^translation missing/i.test(s);
  }

  function napLista(s) {
    if (!ervenyes(s)) return null;
    var lista = s.split('|').map(function (r) { return r.trim(); });
    return lista.length === NAPOK_SZAMA ? lista : null;
  }

  /** A snippet által kiírt szótár; hiányos kulcsnál a magyar tartalék. `teljes` = minden napkifejezés megvan. */
  function szotarBetolt(el) {
    var nyers = {};
    var szEl = el.querySelector('[data-wk-szallit-szotar]');
    if (szEl) { try { nyers = JSON.parse(szEl.textContent) || {}; } catch (e) { nyers = {}; } }
    var reggel = napLista(nyers.nap_reggel);
    var on = napLista(nyers.nap_on);
    var teljes = !!(reggel && on && ervenyes(nyers.holnap_reggel) && ervenyes(nyers.holnap_on) && ervenyes(nyers.bp_videk));
    var utvonal = {};
    Object.keys(nyers.utvonal || {}).forEach(function (k) { if (ervenyes(nyers.utvonal[k])) utvonal[k] = nyers.utvonal[k]; });
    if (!teljes) return { teljes: false, szotar: Object.assign({}, MAGYAR_SZOTAR, { utvonal: utvonal }) };
    return {
      teljes: true,
      szotar: { nap_reggel: reggel, nap_on: on, holnap_reggel: nyers.holnap_reggel, holnap_on: nyers.holnap_on,
        bp_videk: nyers.bp_videk, utvonal: utvonal },
    };
  }

  function napKifejezes(d, ma, szotar, reggel) {
    var holnap = isoNap(d) === isoNap(plusz(ma, 1));
    if (reggel) return holnap ? szotar.holnap_reggel : szotar.nap_reggel[d.getUTCDay()];
    return holnap ? szotar.holnap_on : szotar.nap_on[d.getUTCDay()];
  }

  function nagyBetu(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  /** Helyőrző cseréje; a mondat ELEJÉN álló kifejezés nagybetűvel indul („{atvet} átvehető." → „Holnap átvehető."). */
  function csere(szoveg, helyorzo, ertek) {
    return szoveg.split(helyorzo).map(function (resz, i, reszek) {
      if (i === reszek.length - 1) return resz;
      var elejen = i === 0 && resz.trim() === '';
      return resz + (elejen ? nagyBetu(ertek) : ertek);
    }).join('');
  }

  /** `{ora}` `{felad}` `{atvet}` `{pont}` `{hazhoz}` feloldása a kapott szótárral. */
  function helyorzokFeloldas(szoveg, n, ma, szotar, ora) {
    if (!szoveg || szoveg.indexOf('{') === -1) return szoveg;
    var bpVidek = function (bp, videk) { return szotar.bp_videk.replace('{bp}', bp).replace('{videk}', videk); };
    var egysegesNap = isoNap(n.bp) === isoNap(n.videk);
    var pont = egysegesNap
      ? napKifejezes(n.bp, ma, szotar, true)
      : bpVidek(napKifejezes(n.bp, ma, szotar, true), napKifejezes(n.videk, ma, szotar, true));
    var hazhoz = egysegesNap
      ? napKifejezes(n.bp, ma, szotar, false)
      : bpVidek(napKifejezes(n.bp, ma, szotar, false), napKifejezes(n.videk, ma, szotar, false));
    var ki = szoveg;
    ki = csere(ki, '{ora}', String(ora));
    ki = csere(ki, '{felad}', napKifejezes(n.felad, ma, szotar, false));
    /* bolti átvétel: a Metaboxból a boltba CSAK munkanapon megy áru (user 2026-09-12) → a vidéki (szombat nélküli) nap */
    ki = csere(ki, '{atvet}', napKifejezes(n.videk, ma, szotar, false));
    ki = csere(ki, '{pont}', pont);
    ki = csere(ki, '{hazhoz}', hazhoz);
    return ki;
  }

  /** Helyőrzős sorok elhagyása, ha nincs hozzá nyelvileg helyes szótár (inkább kevesebb, mint hibás mondat). */
  function helyorzosSorokNelkul(szoveg) {
    return szoveg.split('|').map(function (r) { return r.trim(); })
      .filter(function (r) { return r && r.indexOf('{') === -1; }).join(' | ');
  }

  /**
   * A megjelenő mondat egy mezőre. Alapesetben a TEXTICO szövege (a bolt saját nyelvén); ha a látogató MÁS nyelvet
   * néz és a nyelvi fájl ismeri az útvonal-kódot, a fordított mondat. Üres TEXTICO-szöveg = szándékosan nincs kiírás.
   */
  function mondat(p) {
    if (!p.alap) return '';
    var sajat = (!p.nap.aznapFelad && p.utana) ? p.utana : p.alap;
    var forditott = p.forditas ? forditottMondat(p) : '';
    if (forditott) return kitolt(forditott, p, p.szotarTeljes ? p.szotar : null);
    /* a saját nyelvű szövegnél a napkifejezés is a saját nyelvén legyen: a látogatói szótár, ha ugyanaz a nyelv;
       fordításhiány esetén a beépített magyar (ha a szöveg magyar) — különben nyelvkeverék lenne a mondatból */
    var szotar = (!p.forditas && p.szotarTeljes) ? p.szotar : (p.sajatNyelv === 'hu' ? MAGYAR_SZOTAR : null);
    return kitolt(sajat, p, szotar);
  }

  function forditottMondat(p) {
    if (!p.kod) return '';
    var ut = p.szotar.utvonal;
    if (!p.nap.aznapFelad && ut[p.kod + '_utana']) return ut[p.kod + '_utana'];
    return ut[p.kod] || '';
  }

  function kitolt(szoveg, p, szotar) {
    if (szoveg.indexOf('{') === -1) return szoveg;
    return szotar ? helyorzokFeloldas(szoveg, p.nap, p.ma, szotar, p.ora) : helyorzosSorokNelkul(szoveg);
  }

  /* teszteléshez (böngésző-konzolból tetszőleges dátummal hívható) — a felületet nem érinti */
  window.__wkSzallitNaptar = {
    naptar: naptar, helyorzokFeloldas: helyorzokFeloldas, mondat: mondat, maiNap: maiNap, MAGYAR_SZOTAR: MAGYAR_SZOTAR,
  };

  function feldolgoz(el) {
    if (el.dataset.kesz === '1') return;
    var adatEl = el.querySelector('[data-wk-szallit-adat]');
    if (!adatEl) return;
    var adat;
    try { adat = JSON.parse(adatEl.textContent); } catch (e) { return; }
    el.dataset.kesz = '1';
    var aktualis = el.dataset.kivalasztott;
    var betoltott = szotarBetolt(el);
    var lathatoNyelv = (el.dataset.lang || '').toLowerCase();
    var forditas = !!lathatoNyelv && lathatoNyelv !== (el.dataset.sajatNyelv || '').toLowerCase();

    function frissit(vid) {
      aktualis = vid;
      var v = adat.vari[String(vid)];
      var fo = el.querySelector('.wk-szallit__fo');
      var sz = el.querySelector('.wk-szallit__szoveg');
      var boltok = el.querySelector('.wk-szallit__boltok');
      var lista = el.querySelector('.wk-szallit__lista');
      var cutoff = Number(el.dataset.cutoff || 14);
      var mai = maiNap(el.dataset.tz);
      var szunnapok = (el.dataset.szunnapok || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var nap = naptar(mai.nap, mai.ora, cutoff, szunnapok);
      /* a BOLTI átvételnek saját (korábbi) határideje van: a bolt 14:00-ig csomagol/rendel, és a boltba csak
         munkanapon érkezik áru (user 2026-09-12) — eddig a webshopos 16:00-val váltott, ami 14-16 közt tévedett */
      var boltCutoff = Number(el.dataset.cutoffBolt || 14);
      var boltNap = naptar(mai.nap, mai.ora, boltCutoff, szunnapok);
      if (!v) { if (fo) fo.hidden = true; if (boltok) boltok.hidden = true; el.hidden = true; return; }
      /* útvonal-kódok: [online, bolt_1 … bolt_N] — a TEXTICO `<piac>_utvonal` mezőjéből (2026-09-12) */
      var kodok = (v.u || '').split('|');
      var kozos = {
        forditas: forditas, szotar: betoltott.szotar, szotarTeljes: betoltott.teljes,
        sajatNyelv: (el.dataset.sajatNyelv || '').toLowerCase(), ma: mai.nap,
      };
      /* az alapszöveg az AZNAPI feladást ígéri — ha ma már nem indul csomag (cut-off után, hétvégén, ünnepnapon),
         a cut-off utáni szöveg megy; a napneveket a helyőrzők adják (2026-09-12) */
      var szoveg = mondat(Object.assign({}, kozos, { alap: v.o, utana: v.o14, kod: kodok[0], nap: nap, ora: cutoff }));
      if (szoveg) {
        /* "|" elválasztó = több sor (pl. csomagpont vs házhozszállítás külön ígérete) */
        var reszek = szoveg.split('|').map(function (r) { return r.trim(); }).filter(Boolean);
        sz.textContent = '';
        reszek.forEach(function (resz, i) {
          var sorEl = document.createElement('span');
          sorEl.className = 'wk-szallit__sor' + (i === 0 ? ' wk-szallit__sor--fo' : '');
          sorEl.textContent = resz;
          sz.appendChild(sorEl);
        });
        fo.hidden = false;
      } else fo.hidden = true;
      if (boltok && lista) {
        lista.textContent = '';
        /* azonos címkéjű boltok EGY sorban (user-kérés 2026-08-19: az „azonnal átvehető" csak egyszer) */
        var csoport = {}, sorrend = [], azonnali = {};
        (v.b || []).forEach(function (b) {
          var kod = kodok[Number(b[3])] || '';
          var t = mondat(Object.assign({}, kozos, { alap: b[1], utana: b[2], kod: kod, nap: boltNap, ora: boltCutoff }));
          if (!t) return;
          if (!csoport[t]) { csoport[t] = []; sorrend.push(t); }
          csoport[t].push(b[0]);
          if (kod === 'bolt_helyben' || /azonnal|ihned|ihneď|sofort|now/i.test(t)) azonnali[t] = true;
        });
        /* az „azonnal átvehető" csoport mindig ELÖL (user 2026-08-24), a többi a bolt-sorrendben utána */
        sorrend.sort(function (a, b) { return (azonnali[b] ? 1 : 0) - (azonnali[a] ? 1 : 0); });
        sorrend.forEach(function (t) {
          var li = document.createElement('li');
          var pont = document.createElement('span');
          pont.className = 'wk-szallit__pont' + (azonnali[t] ? ' wk-szallit__pont--zold' : '');
          var ert = document.createElement('span'); ert.className = 'wk-szallit__ertek';
          ert.textContent = t.replace(/\.$/, '') + ': ';
          var nev = document.createElement('span'); nev.className = 'wk-szallit__bolt';
          nev.textContent = csoport[t].join(', ');
          li.appendChild(pont); li.appendChild(ert); li.appendChild(nev);
          lista.appendChild(li);
        });
        boltok.hidden = sorrend.length === 0;
      }
      el.hidden = fo.hidden && (!boltok || boltok.hidden);
    }

    frissit(el.dataset.kivalasztott);

    /* a kiválasztott variáns HITELES forrása: a termék-űrlap rejtett id-mezője (a téma minden választónál ezt állítja — rádió, legördülő,
       mobil), tartalék az URL ?variant= paramétere; így a szkript nem függ a választó eseményeitől (user 2026-09-06, iPhone) */
    function aktualisVarians() {
      var inp = document.querySelector('form[action*="/cart/add"] input[name="id"]') || document.querySelector('input[name="id"][form]');
      var vid = inp && inp.value;
      if (!vid) { try { vid = new URL(window.location.href).searchParams.get('variant'); } catch (e) { vid = null; } }
      return vid || aktualis;
    }

    if (el.dataset.mod === 'pdp') {
      setInterval(function () { var vid = aktualisVarians(); if (vid && String(vid) !== String(aktualis)) frissit(vid); }, 500);
      if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
        window.subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
          var v = e && e.data && e.data.variant;
          if (v && v.id) frissit(v.id);
        });
      }
      /* tartalék: az URL ?variant= paraméterét is figyeljük variáns-állításkor */
      document.addEventListener('change', function (ev) {
        if (!ev.target.closest) return;
        if (!ev.target.closest('variant-selects, variant-radios, .product-form__input')) return;
        setTimeout(function () { var vid = aktualisVarians(); if (vid) frissit(vid); }, 700);
      });
      /* időzített újraszámolás (cut-off átlépése nyitva hagyott lapon) */
      setInterval(function () { frissit(aktualisVarians()); }, 5 * 60 * 1000);
    }
  }

  function mind() {
    document.querySelectorAll('[data-wk-szallit]').forEach(feldolgoz);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mind);
  else mind();
  new MutationObserver(function () { mind(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
